<template>
  <div class="wrapper">
    <div class="left-sidebar">
      <LeftNews />
    </div>
    <div class="main-content">
      <router-view/>
    </div>
    <div class="right-sidebar">
      <RightNews />
    </div>
  </div>

</template>
<script>
import LeftNews from '@/views/components/LeftNews'
import RightNews from '@/views/components/RightNews'
export default {
  components: {
    LeftNews,
    RightNews
  },
  created() {
    console.log('moment', this.$moment().format("HH:mm"))
  }
}
</script>
<style lang="scss">
  @import './assets/css/style.css';

  /* Import Font Awesome 5 Icons Set */
  $fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
  @import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-free/scss/solid.scss';
  @import '~@fortawesome/fontawesome-free/scss/regular.scss';
  @import '~@fortawesome/fontawesome-free/scss/brands.scss';
</style>
